import React from 'react';

import { Loader } from './LoadingComponentStyle';

export const LoadingComponent = () => (
    <Loader className="flex-container flex-center">
        <div className="loader-inner" />
    </Loader>
);



// WEBPACK FOOTER //
// ./src/components/loading/LoadingComponent.js